export default __webpack_public_path__ + "static/media/lesson_flow003.5b3abd21.png";